export enum UserRoleEnum {
    USER = 0,
    ADMIN = 1,
    READ = 2,
    WRITE = 3
}